import { jsx as r } from "react/jsx-runtime";
function i(t) {
  return /* @__PURE__ */ r(
    "svg",
    {
      width: "30",
      height: "30",
      viewBox: "0 0 30 30",
      fill: "rgb(var(--text-primary))",
      xmlns: "http://www.w3.org/2000/svg",
      ...t,
      children: /* @__PURE__ */ r("path", { d: "M0 7.67967V18.6666C0.00996094 21.151 2.03906 23.1502 4.51348 23.1402H20.5277C20.983 23.1402 21.3492 22.774 21.3492 22.3287V11.3424C21.3393 8.85799 19.3107 6.85818 16.8357 6.86814H0.821484C0.366211 6.86814 0 7.23435 0 7.67967ZM22.3688 11.9658L28.9805 7.13533C29.5547 6.66072 30 6.77908 30 7.64041V22.3679C30 23.3482 29.4557 23.2293 28.9805 22.873L22.3688 18.0525V11.9658Z" })
    }
  );
}
export {
  i as ZoomIcon
};
